function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_925",
  "data-name": "Group 925",
  transform: "translate(2021.078 -1800.982)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_924",
  "data-name": "Group 924",
  transform: "translate(-2021.078 1800.982)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_923",
  "data-name": "Group 923",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_922",
  "data-name": "Group 922"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_921",
  "data-name": "Group 921"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_1039",
  "data-name": "Path 1039",
  d: "M683.979,0a10.828,10.828,0,0,0-10.7,10.963,10.939,10.939,0,0,0,7.463,10.451l2.434,3.677a.96.96,0,0,0,1.61,0l2.434-3.677a10.939,10.939,0,0,0,7.463-10.451A10.828,10.828,0,0,0,683.979,0Z",
  transform: "translate(-673.278 0)",
  fill: "current"
})))), /*#__PURE__*/React.createElement("path", {
  id: "Path_1040",
  "data-name": "Path 1040",
  d: "M872.426,182.774c-.53,0-.907.224-.907.554v4.489c0,.283.377.566.907.566.507,0,.919-.283.919-.566v-4.489C873.345,183,872.933,182.774,872.426,182.774Z",
  transform: "translate(-861.724 -173.129)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_104",
  "data-name": "Ellipse 104",
  cx: 0.96,
  cy: 0.96,
  r: 0.96,
  transform: "translate(9.748 5.756)",
  fill: "#fff"
})));

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.403,
    height: 25.528,
    viewBox: "0 0 21.403 25.528",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.03b3d327.svg";
export { ForwardRef as ReactComponent };